import React from "react";
import SimplePage from "./SimplePage";

const About: React.FC = () => {
  return (
    <SimplePage title="About Tally">
      <p>
        Tally was built for one reason — most Nigerian shop owners never
        know when a good customer stops coming. By the time they notice,
        that customer is usually gone for good.
      </p>
      <p>
        We built Tally to fix that. Every sale is recorded with a simple
        code. Every customer who redeems that code is remembered. And the
        moment someone who used to come regularly goes quiet, you're told —
        in time to actually bring them back.
      </p>

      <h2>Why we built this</h2>
      <p>
        Walking into shops across Lagos, Port Harcourt, and Abuja, we kept
        hearing the same thing — "I don't even know who my real customers
        are anymore." Notebooks get lost. WhatsApp chats get buried.
        Customers disappear with no explanation.
      </p>
      <p>
        Tally exists to give every Nigerian shop owner — no matter how
        small — the same customer intelligence that big retail chains take
        for granted, without the cost or the complexity.
      </p>

      <h2>What we believe</h2>
      <p>
        We believe a customer who already bought from you once is worth far
        more than a stranger you've never met. We believe loyalty should be
        rewarded, not assumed. And we believe every shop owner deserves to
        know exactly what's happening in their own business.
      </p>

      <h2>Get in touch</h2>
      <p>
        Have a question, a suggestion, or just want to say hello? Reach us
        at <a href="mailto:hello@gettally.store">hello@gettally.store</a>.
      </p>
    </SimplePage>
  );
};

export default About;